import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const SuperBrandsHeroBanner = dynamic(async () => {
  return (await import("./HeroBanner")).default;
});

Builder.registerComponent(SuperBrandsHeroBanner, {
  name: "SuperBrands Hero Banner",
  inputs: [
    {
      name: "imageOrVideo",
      type: "string",
      default: "image",
      enum: ["image", "video"],
      helperText: "Choose Image or Video",
    },
    {
      name: "imageDesktop",
      type: "file",
      allowedFileTypes: ["jpeg", "png", "gif"],
      helperText: "Image file for desktop",
      showIf: `!options.get('imageOrVideo') || options.get('imageOrVideo') == "image"`,
    },
    {
      name: "imageTablet",
      type: "file",
      allowedFileTypes: ["jpeg", "png", "gif"],
      helperText: "Image file for tablet",
      showIf: `!options.get('imageOrVideo') || options.get('imageOrVideo') == "image"`,
    },
    {
      name: "imageMobile",
      type: "file",
      allowedFileTypes: ["jpeg", "png", "gif"],
      helperText: "Image file for mobile",
      showIf: `!options.get('imageOrVideo') || options.get('imageOrVideo') == "image"`,
    },
    {
      name: "videoDesktop",
      type: "file",
      allowedFileTypes: ["mp4"],
      helperText: "Video file for desktop",
      showIf: `options.get('imageOrVideo') == "video"`,
    },
    {
      name: "videoTablet",
      type: "file",
      allowedFileTypes: ["mp4"],
      helperText: "Video file for tablet",
      showIf: `options.get('imageOrVideo') == "video"`,
    },
    {
      name: "videoMobile",
      type: "file",
      allowedFileTypes: ["mp4"],
      helperText: "Video file for mobile",
      showIf: `options.get('imageOrVideo') == "video"`,
    },
    {
      name: "imgAltText",
      type: "string",
      helperText: "alt text for image",
    },
    {
      name: "fallbackImageDesktop",
      type: "file",
      allowedFileTypes: ["jpeg", "png", "gif"],
      helperText: "Fallback image for the video for desktop",
      showIf: `options.get('imageOrVideo') == "video"`,
    },
    {
      name: "fallbackImageTablet",
      type: "file",
      allowedFileTypes: ["jpeg", "png", "gif"],
      helperText: "Fallback image for the video for tablet",
      showIf: `options.get('imageOrVideo') == "video"`,
    },
    {
      name: "fallbackImageMobile",
      type: "file",
      allowedFileTypes: ["jpeg", "png", "gif"],
      helperText: "Fallback image for the video for mobile",
      showIf: `options.get('imageOrVideo') == "video"`,
    },
    {
      name: "backgroundColor",
      type: "string",
      defaultValue: "Oat",
      enum: toolkitColors,
      helperText: "Background color to be added for the Content Row",
    },
    {
      name: "header",
      type: "string",
      helperText: "Header Text (Character limit - 30)",
      onChange: (options) => {
        if (options.get("header").length > 30) {
          options.set("header", options.get("header").slice(0, 30));
          alert(`Maximum number of characters is 30`);
        }
      },
    },
    {
      name: "body",
      type: "longText",
      helperText: "Body Text (Character limit - 115)",
      onChange: (options) => {
        if (options.get("body").length > 115) {
          options.set("body", options.get("body").slice(0, 115));
          alert(`Maximum number of characters is 115`);
        }
      },
    },
    {
      name: "ctaText",
      type: "string",
      helperText: "CTA Text (Character limit - 30)",
      onChange: (options) => {
        if (options.get("ctaText").length > 30) {
          options.set("ctaText", options.get("ctaText").slice(0, 30));
          alert(`Maximum number of characters is 30`);
        }
      },
    },
    {
      name: "ctaLink",
      type: "url",
      helperText: "CTA destination URL",
    },
  ],
});
